import React, { useState } from 'react'
import { Icon, Input, Spin, Modal, Button, message, Popover, Tooltip } from "antd"
import { getOrderForPackaging, markOrderPackaged } from '../../../services/api/3dApi'
import { NavLink } from 'react-router-dom'
import moment from 'moment'
import * as applyBrandingForAllItems from "../../../configs/applyBrandingForAllItems"

function MarkPackagedPageSpecifications(props) {
    const { processingOrder, sku, skuSizes, noteOrder, isMoreTag } = props
    const { brand, brandKit, thankCard, preview_image, procedure, size, brand_name, meta = {} } = processingOrder
    const { packed_method } = meta || {}

    const setHoverOrder = (order, visible) => () => {
        //setHoverOrderState(visible ? order : false)

        return visible
    }
    const [isOpenPreview, setIsOpenPreview] = useState(false)
    const [preview, setPreview] = useState('')

    const getPreviewImageContent = (order) => {
        return <img src={order.preview_image} key={order._id} alt='preview' />
    }

    const handleShowPreview = (url) => {
        setIsOpenPreview(true)
        setPreview(url)
    }

    const handleClosePreview = () => {
        setIsOpenPreview(false)
        setPreview('')
    }

    const PreviewImage = (props) => {
        const {
            order,
            placement = 'left',
        } = props

        return <div
            className={['PreviewPrinting'].filter(Boolean).join(' ')} key={order._id}
            onMouseEnter={setHoverOrder(order, true)}
            onMouseOut={setHoverOrder(order, false)}
        >
            <Popover content={getPreviewImageContent(order)}
                placement={placement}
                trigger="hover"
                key={order._id}>
                <img
                    src={order.preview_image}
                    alt='preview'
                    style={{
                        width: 300,
                        objectFit: 'contain'
                    }}
                />
            </Popover>
        </div>
    }

    const StandardBlock = () => {
        const { sku } = props
        const mess = (sku && sku.packed_description || 'Đóng gói tiêu chuẩn')
            .replace(/\n|\\n/g, '<br />')
            .replace("\n|\\n", '<br />')

        return <div className="Block StandardBlock">
            <p dangerouslySetInnerHTML={{ __html: mess }} />
        </div>
    }

    const BrandBlock = () => {
        return (
            <div className={["Block BrandBlock", (isThankCard() || isBrandKit()) && 'HasThankCardOrBrandKit'].filter(Boolean).join(' ')}>
                <div className="row">
                    <div className="col-12 ColName">
                        <div className="brand-title">
                            Brand <span className="InfoBrand badge text-bg-danger ml-4">{brand.name}</span>
                        </div>
                        <div className="ColContent">
                            {
                                !!(packagingTags && packagingTags.length) &&
                                <div className="ListTags">
                                    {
                                        packagingTags.map(tag => {
                                            const { id, name = '', quantity_per_item = 1, description = '', note = '', design = '' } = Object.assign({}, tag)
                                            return (
                                                <div className="row mb-3" key={id}>
                                                    <div className="col-md-6">
                                                        <Tooltip title={note} placement={"right"}>
                                                            <div style={{ wordWrap: 'break-word' }}>
                                                                {
                                                                    [
                                                                        <span>{name}</span>,
                                                                        <span>(Qty = {quantity_per_item})</span>,
                                                                        description && <span>: {description}</span>
                                                                    ].filter(Boolean)
                                                                }
                                                            </div>
                                                        </Tooltip>
                                                    </div>
                                                    <div className="col-md-6">
                                                        {
                                                            !!design &&
                                                            <div className="images-brand posititon-relative">
                                                                <img src={design} alt='preview' width={300} loading='lazy' />
                                                                <div className='Icon'>
                                                                    <Icon className='eye-icon' type="eye" onClick={() => handleShowPreview(design)} />
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )

    }

    const ThankCardBlock = () => {
        return <>
            {
                thankCard.map(order => {
                    return <div className="Block ThankCardBlock" key={order._id}>
                        <div className="d-flex justify-content-between">
                            <div className="ColName">Thank card</div>
                            <div className="ColContent">
                                <div className={['PreviewPrinting'].filter(Boolean).join(' ')}>
                                    <PreviewImage order={order} placement="topRight" />
                                </div>
                            </div>
                        </div>
                    </div>
                })
            }
        </>
    }

    const BrandKitBlock = () => {
        const bkItems = isAppliedBrandingForAllItems ? [brandKit[0]] : brandKit

        return <>
            {
                bkItems.map(order => {
                    return <div className="Block BrandKitBlock" key={order._id}>
                        <div className="row">
                            <div className="col-md-3 ColName">Brand kit</div>
                            <div className="col-md-9 ColContent">
                                <PreviewImage order={order} />
                            </div>
                        </div>
                    </div>
                })
            }
        </>
    }

    const getPackingInfo = (skuSizes, sku) => {
        const priorityKeys = ['brand', 'shipping-carrier', 'default']

        let preferredData = null

        for (const key of priorityKeys) {
            if (skuSizes[key] && skuSizes[key].package_description) {
                preferredData = skuSizes[key]
                break
            }
        }

        if (!preferredData) {
            if (skuSizes['default'] && skuSizes['default'].package_description) {
                preferredData = skuSizes['default']
            } else {
                preferredData = sku || {}
            }
        }
        return preferredData || {}
    }

    const packagingTags = brand && brand.rule && brand.rule.current_tags ? brand.rule.current_tags.filter(tag => tag.type === 'packaging') : []
    const hasBrand = !!packagingTags.length
    const isThankCard = () => !!(thankCard && thankCard.length)
    const isBrandKit = () => !!(brandKit && brandKit.length)
    const isStandard = () => !!(!hasBrand && !isThankCard() && !isBrandKit() && !sku.packed_description)
    const isAppliedBrandingForAllItems = applyBrandingForAllItems.isSupport(processingOrder && processingOrder.barcode)

    const packingInfo = getPackingInfo(skuSizes, sku)

    const { optimization = {}, sku: variantSize, package_description, packed_description, package_mockup = [] } = { ...packingInfo }

    return (
        <div className={`MarkPackagedPageSpecifications ${noteOrder && 'position-absolute w-100'}`} style={{ top: noteOrder ? (isMoreTag ? '105px' : '65px') : 0 }}>
            <div className="header-content BoxHeading d-flex justify-content-between align-items-center flex-wrap">
                <h3 className="mb-0">Quy cách đóng gói</h3>
                {(!!packed_method || packed_method === '') &&
                    <h5 className="mb-0">{packed_method === 'vacuum' ? 'Hút chân không' : 'Đóng gói thường'}</h5>
                }
            </div>
            <div className="BoxContent">
                <div
                    className={["Block PackedDescriptionBlock pb-3", (isThankCard() || isBrandKit() || hasBrand) && 'HasThankCardOrBrandKit'].filter(Boolean).join(' ')}>
                    {procedure === '3D' ?
                        (Object.keys(packingInfo).length > 0 ?
                            <>
                                <div className="d-flex align-items-center">
                                    <div className="ColName">Mô tả đóng gói
                                        {optimization.type === 'brand' &&
                                            <span className="InfoBrand badge text-bg-danger mx-2">{optimization.name}</span>
                                        }
                                        {optimization.type === 'shipping-carrier' &&
                                            <span className="ColName mx-1">- {optimization.name === 'default' ? 'Mặc định' : optimization.name}</span>
                                        }
                                    </div>
                                </div>
                                {(package_description || packed_description) ?
                                    <div className="ColContent">
                                        <p style={{ whiteSpace: 'pre-line' }}>{package_description && variantSize ? `${variantSize} - ` : ''}{package_description || packed_description}</p>
                                    </div> :
                                    (!Object.keys(packingInfo).length && sku.packed_description &&
                                        <div className="ColContent">
                                            <p style={{ whiteSpace: 'pre-line' }}>{sku.packed_description || 'Đóng gói tiêu chuẩn'}</p>
                                        </div>
                                    )
                                }
                                {package_mockup.length > 0 ?
                                    <div className="ImagePreview position-relative d-flex flex-wrap mt-3">
                                        {package_mockup.map((i, index) => (
                                            <div className='mx-1' key={`image_${index}`} style={{ width: '30%' }}>
                                                <img src={i} className='previewImage' alt='preview' />
                                            </div>
                                        ))}
                                    </div> :
                                    (sku['package_mockup'] && sku['package_mockup'].length > 0 &&
                                        <div className="ImagePreview position-relative d-flex flex-wrap mt-3">
                                            {sku['package_mockup'].map((i, index) => (
                                                <div className='mx-1' key={`image_${index}`} style={{ width: '30%' }}>
                                                    <img src={i} className='previewImage' alt='preview' />
                                                </div>
                                            ))}
                                        </div>
                                    )
                                }
                            </> :
                            <>
                                <div className="row">
                                    <div className="col-md-3 ColName">Mô tả đóng gói</div>
                                    <div className="col-md-9 ColContent">
                                        <p style={{ whiteSpace: 'pre-line' }}>{sku.packed_description || 'Đóng gói tiêu chuẩn'}</p>
                                    </div>
                                </div>
                                {sku['package_mockup'] && sku['package_mockup'].length > 0 &&
                                    <div className="ImagePreview position-relative d-flex flex-wrap mt-3">
                                        {sku['package_mockup'].map((i, index) => (
                                            <div className='mx-1' key={`image_${index}`} style={{ width: '30%' }}>
                                                <img src={i} className='previewImage' alt='preview' />
                                            </div>
                                        ))}
                                    </div>
                                }
                            </>
                        ) :
                        <div className="row">
                            <div className="col-md-3 ColName">Mô tả đóng gói</div>
                            <div className="col-md-9 ColContent">
                                <p style={{ whiteSpace: 'pre-line' }}>{sku.packed_description || 'Đóng gói tiêu chuẩn'}</p>
                            </div>
                        </div>
                    }
                </div>

                {
                    !!preview && isOpenPreview &&
                    <Modal
                        visible={isOpenPreview}
                        onCancel={handleClosePreview}
                        closable={false}
                        footer={false}
                        width={"50vw"}
                        height={"75vh"}
                    >
                        <img
                            src={preview}
                            alt="preview"
                            width={"100%"}
                            style={{ objectFit: 'contain' }}
                        />
                    </Modal>
                }

                {
                    hasBrand && <BrandBlock />
                }

                {/* {
                    isThankCard() && <ThankCardBlock />
                }

                {
                    isBrandKit() && <>
                        {
                            isAppliedBrandingForAllItems &&
                            <p className="alert alert-danger">Đóng gói 1 item / 1 túi zip/ 1 BrandKit</p>
                        }
                        <BrandKitBlock />
                    </>
                } */}
            </div>
        </div>
    )
}

export default MarkPackagedPageSpecifications